__turbopack_context__.v({
  "actions": "error-module__48vcWq__actions",
  "content": "error-module__48vcWq__content",
  "details": "error-module__48vcWq__details",
  "digest": "error-module__48vcWq__digest",
  "page": "error-module__48vcWq__page",
  "panel": "error-module__48vcWq__panel",
  "summary": "error-module__48vcWq__summary",
});
